import { Box, Button } from '@mui/material'
import { Stack } from '@mui/system'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { getPaymentModeTableData, paymentModeDropData, paymentModeSave } from '../../../../../store/generalSetting/GSAction'
import DropDownOA from '../../../../common/dropDownOA'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import PaymentModeTable from './PaymentModeTable'
import { useTranslation } from '../../../../../i18n/I18nProvider'


const PaymentMode = (props) => {
    const { data, updateModal, updateAlertError, paymentModeDropData, getPaymentModeTableData, paymentModeSave } = props
    const { common, generalSettingReducer } = data
    const { paymentModeTableData } = { ...generalSettingReducer }
    const { loginData, showModal, modalType } = common
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const successId = { id: 'PaymentModeSaved', lrListLabel: 'Saved Payment Mode', isSaved: false }

    const [companyDropData, setCompanyDropData] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const [showTable, setShowTable] = useState(false)
    const [showTableData, setShowTableData] = useState([])
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const obj = {
                intCompanyID: loginData?.intCompanyID,
                intUserID: loginData?.intUserID,
                intMode: 1
            }
            paymentModeDropData(obj, true, 24 * 60 * 60 * 1000).then((res) => {
                if (res?.status == 'Success') {
                    setCompanyDropData(res?.Data?.Table || [])
                    let companyObj = res?.Data?.Table?.filter((val) => loginData?.intCompanyID == val?.CompanyID)?.[0]
                    setSelectedCompany(companyObj || "")
                    const obj = {
                        CompanyID: companyObj?.CompanyID
                    }
                    getPaymentModeTableData(obj)
                    setShowTable(true)
                } else {
                    updateAlertError({ show: true, msg: res.ErrMessage })
                }
            }).catch((err) => {
                updateAlertError({ show: true, message: err })
            })
        }
    }, [loginData])
    useEffect(() => {
        if (paymentModeTableData?.Table?.length > 0) {
            const updatedData = paymentModeTableData?.Table?.map((val) => ({ ...val, IsBranchCheck: 0 }))
            setShowTableData(updatedData)
            setTableData(updatedData)
        } else {
            setShowTableData([])
        }
    }, [paymentModeTableData])
    useEffect(() => {
        focusElemnt("PayModeCompanyName")
    }, [])
    const handleClick = () => {
        if (selectedCompany === "") {
            updateAlertError({ show: true, msg: tr('selectCompany', 'Select Company'), nextId: "PayModeCompanyName" })
        } else {
            const obj = {
                CompanyID: selectedCompany?.CompanyID
            }
            getPaymentModeTableData(obj)
            setShowTable(true)
        }
    }
    const transferArrToObject = (arr) => {
        const newObject = arr.reduce((result, obj) => {
            Object.keys(obj).forEach(key => {
                result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
            });
            return result;
        }, {});
        return newObject
    }
    const saveApi = () => {
        if (showTableData?.length > 0) {
            const newData = showTableData?.filter((val) => val.IsBranchCheck == 1) || []
            const formatedData = transferArrToObject(newData)
            const obj = {
                UserID: loginData?.intUserID,
                BranchID: formatedData?.BranchID,
                IsCreditDebit: formatedData?.IsCreditDebit,
                IsNetBank: formatedData?.IsNetBanking,
                IsUPI: formatedData?.IsUPI,
                IsCheque: formatedData?.IsCheque
            }
            paymentModeSave(obj).then((res) => {
                if (res?.status == 'success') {
                    updateModal(true, "PaymentModeSaved");
                } else {
                    if (newData?.length > 0) {
                        updateAlertError({ show: true, msg: res.Message })
                    } else {
                        updateAlertError({ show: true, msg: tr('pleaseSelectAtleastOneBranch', 'Please Select Atleast One Branch') })
                    }
                }
            }).catch((err) => {
                updateAlertError({ show: true, message: err })
            })
        }
    }
    const modalClose = () => {
        const obj = {
            CompanyID: selectedCompany?.CompanyID
        }
        getPaymentModeTableData(obj)
        updateModal(false, "PaymentModeSaved")
        focusElemnt("PayModeCompanyName")
    }
    const SuccessModal = () => {
        return (
            <Modal headTxt={tr('paymentModeSaved', 'Payment Mode Saved Successfully')} modalStyle={modalStyle} modalClass={'booking-popup'} width={"25%"} closeId={"closeButton"} updateModal={updateModal} sx={{ marginTop: '20px' }}>
                <Stack>
                    <Box style={{ margin: '10px', fontSize: '17px' }}>
                        <div> {tr('paymentModeSavedExcl', 'Payment Mode Saved Successfully!')}</div>
                    </Box>
                </Stack>
                <Stack>
                    <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
                        {/* <button
                            autoFocus
                            style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
                            onClick={() => modalClose()}
                        >
                            Ok
                        </button> */}
                        <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "PayModeSaveBtn", "PayModeCompanyName", () => { })} >
                            <Button
                                autoFocus={true}
                                variant="contained"
                                style={{ ...sx.fullHeight, ...sx.novp }}
                                className="btn btn-primary"
                                onClick={() => modalClose()}
                            >
                                {tr('gsOk', 'Ok')}
                            </Button>
                        </Item>
                    </div>
                </Stack>
            </Modal>
        )
    }

    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                <Box sx={sx.reportFlex} className='itemButtons' style={{ paddingLeft: "0px", paddingRight: "0px", paddingTop: "7px" }}>
                    <Item sx={sx.itemsx} style={{ width: "300px" }}>
                        <DropDownOA
                            id="PayModeCompanyName"
                            label={tr('selectCompany', 'Select Company')}
                            defaultvalue={selectedCompany?.CompanyName || selectedCompany}
                            width="100%"
                            dataKey={`CompanyName`}
                            idKey={`CompanyID`}
                            data={companyDropData || []}
                            nextId={"PayModeGoBtn"}
                            prevId={"PayModeSaveBtn"}
                            onSelect={(value) => setSelectedCompany(value)}
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "PayModeSaveBtn", "PayModeCompanyName", () => { })} >
                        <Button
                            id="PayModeGoBtn"
                            variant="contained"
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                            onClick={() => handleClick()}
                        >
                            {tr('gsGo', 'Go')}
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, }} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, showTable ? "Contains-1" : "PayModeCompanyName", "PayModeGoBtn", () => { })} >
                        <Button id="PayModeSaveBtn" variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                            onClick={() => saveApi()}
                        >
                            {tr('saveTitle', 'Save')}
                        </Button>
                    </Item>
                </Box>
                <Box style={{ marginTop: "12px" }}>
                    {
                        showTable && <PaymentModeTable table={showTableData} setShowTableData={setShowTableData} tableData={tableData} />
                    }
                </Box>
            </Item>
            {showModal && [successId.id].includes(modalType) && SuccessModal(successId.id)}
        </>
    )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, paymentModeDropData, getPaymentModeTableData, paymentModeSave
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMode)
